import { HomeState } from '@/modules/Home/store/state';
import { Commit } from 'vuex';

export interface HomeActionTypes {
    commit: Commit,
    state: HomeState,
    getters: any,
}

export enum HomeAction {
    SHOW_HOMEPAGE_MODAL = 'SHOW_HOMEPAGE_MODAL',
    SEEN = 'SEEN',
    DONT_SHOW = 'DONT_SHOW',
    KNOW_MORE = 'KNOW_MORE',
    CONTACT_ME = 'CONTACT_ME',
    RESET_MODULES = 'HOME_RESET_MODULES',
    GET_ACTUALITES = 'GET_ACTUALITES',
    SET_ACTUALITE_VUE = 'SET_ACTUALITE_VUE',
    SET_ACTUALITE_OPEN = 'SET_ACTUALITE_OPEN',
    GET_NB_NOUVELLES_RECLAMATIONS = 'GET_NB_NOUVELLES_RECLAMATIONS',
    GET_LANGUES = 'GET_LANGUAGES',
    SET_LANGUE = 'SET_LANGUAGES',
    GET_LANGUE_SELECTIONNEE = 'GET_LANGUE_SELECTIONNEE',
    GET_TRADUCTIONS = 'GET_TRADUCTIONS',
    GET_DASHBOARDS = 'GET_DASHBOARDS',
    GET_DASHBOARD = 'GET_DASHBOARD',
    GET_WIDGETS_DISPONIBLES = 'GET_WIDGETS_DISPONIBLES',
    SET_DASHBOARD = 'SET_DASHBOARD',
    PUT_DASHBOARD = 'PUT_DASHBOARD',
    CHANGE_WIDGET_POSITION = 'CHANGE_WIDGET_POSITION',
    DELETE_DASHBOARD = 'DELETE_DASHBOARD',
    POST_WIDGET = 'POST_WIDGET',
    DELETE_WIDGET = 'DELETE_WIDGET',
}
